export enum NudgePriority {
  Normal = 1,
  High
}

export enum NudgePriorityTitle {
  Normal = 'Normal',
  High = 'High'
}
